// extracted by mini-css-extract-plugin
export default {"toggle":"_1ID2Cjw6_M28cuWeyFXpUy","bold":"-HuDvqFImQUu2I8yg_Tn","modal":"_2fq3cuj_3Vnm6_N3pnE5A9"};